module.exports = __webpack_public_path__ + "img/home-active.ebd4d7a0.svg";